export const FILTER_KEY_ID: string = 'id';
export const FILTER_KEY_NAME: string = 'name';
